import TagManagerUtil from '@/scripts/tag-manager-util';
import { sendTrackingEvent } from '@/scripts/tracking-util';

function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export default {
  methods: {
    sendTrackingEvent(eventName, value, invalid = false) {
      if (!invalid) {
        TagManagerUtil.sendEvent(eventName, value);

        const eventValue = isObject(value) ? value : { data: value };
        sendTrackingEvent(eventName, eventValue);
      }
    },
    sendTrackingEventOnChange(fieldName, fieldValidation, action, event) {
      if (action) {
        this.$emit(action, event);
      }
      this.sendTrackingEvent('onboarding_field_changed', fieldName, fieldValidation);
    },
  },
};
